import AuthApi from "@/general/api/authApi";
import auth, { AuthState } from "@/general/store/modules/auth";
import { Company, UserInfo, Account } from "@/general/store/models";
import { Mutation } from "vuex-module-decorators";

export default class LocalStorage {
  /** Get value of key
   * @param string key
   * @returns string | null
   */
  public static getItem = (key: string): string | null => {
    console.log("called storage getItem:" + key);
    if (key === "userDetails") {
      // userDetailsがlocalStorageに入っていたらそれを返す。
      // が、データ自体をリフレッシュするため事前をAPIからコールして取得しておく
      return LocalStorage.getUserDetails();
    } else if (key === "OrgSpecificData") {
      // OrgSpecificDataがlocalStorageに入っていたらそれを返す。
      // が、データ自体をリフレッシュするため事前をAPIからコールして取得しておく
      return LocalStorage.getOrgSpecificData();

      // } else if (key === "userPointsDetails") {
      //   return JSON.stringify(getUserProfileSummary());
    }
    return localStorage.getItem(key);
  };

  /**
   * Set value of key
   * @param string key
   * @param string value
   * @returns void
   */
  public static setItem = (key: string, value: string): void => {
    // if (key === "userDetails") {
    //   LocalStorage.innerLocalStorage.userDetails = value;
    //   return;
    // } else if (key === "OrgSpecificData") {
    //   LocalStorage.innerLocalStorage.orgSpecificData = value;
    //   return;
    // }
    localStorage.setItem(key, value);
  };

  /**
   * Remove value of key
   * @param string key
   * @param string value
   * @returns void
   */
  public static removeItem = (key: string): void => {
    localStorage.removeItem(key);
  };

  /**
   * Remove all localstorage
   *
   * @returns void
   */
  public static removeAll = (): void => {
    localStorage.clear();
    // LocalStorage.innerLocalStorage.userDetails = "";
    // LocalStorage.innerLocalStorage.orgSpecificData = "";
  };

  // private static innerLocalStorage = {
  //   userDetails: "",
  //   orgSpecificData: ""
  // };
  /**
   * userDetailsがlocalStorageに入っていたらそれを返す。
   * が、データ自体をリフレッシュするため事前をAPIからコールして取得しておく
   * @returns
   */
  @Mutation
  private static getUserDetails(): string | null {
    // const userDetailsString = LocalStorage.innerLocalStorage.userDetails;
    const userDetailsString = localStorage.getItem("userDetails");
    if (userDetailsString) {
      AuthApi.getICSession().then((result) => {
        const ic_session = JSON.parse(result);
        // console.log(ic_session);
        AuthApi.getUserInfoRead(ic_session.companyCd).then((userInfoRead) => {
          // console.log("userInfoRead:");
          // console.log(userInfoRead);
          if (userInfoRead) {
            const payload: AuthState = {} as AuthState;
            let users: UserInfo = {} as UserInfo;
            users = userInfoRead;
            payload.user = users;
            payload.authenticate = true;
            auth.setUser(payload);
            auth.setAuthentication(payload);
            // console.log(auth.authenticate);
            // console.log(users.access_token);
          }
          // #59042対応によりpage_logo、point_logo、favicon、avatar、rankImagePc、rankImageSpをローカルストレージ上に保存しないように修正
          delete userInfoRead.page_logo;
          delete userInfoRead.point_logo;
          delete userInfoRead.favicon;
          delete userInfoRead.avatar;
          delete userInfoRead.rankImagePc;
          delete userInfoRead.rankImageSp;
          localStorage.setItem("userDetails", JSON.stringify(userInfoRead));
          // LocalStorage.innerLocalStorage.userDetails = JSON.stringify(userInfoRead);

          return JSON.stringify(userInfoRead);
        });
      });
      return userDetailsString;
    } else {
      AuthApi.getICSession().then((result) => {
        const ic_session = JSON.parse(result);
        // console.log(ic_session);
        AuthApi.getUserInfoRead(ic_session.companyCd).then((userInfoRead) => {
          // console.log("userInfoRead:");
          // console.log(userInfoRead);
          const payload: AuthState = {} as AuthState;
          let users: UserInfo = {} as UserInfo;
          users = userInfoRead;
          payload.user = users;
          payload.authenticate = true;
          auth.setUser(payload);
          auth.setAuthentication(payload);
          // console.log(auth.authenticate);
          // console.log(users.access_token);

          // #59042対応によりpage_logo、point_logo、favicon、avatar、rankImagePc、rankImageSpをローカルストレージ上に保存しないように修正
          delete userInfoRead.page_logo;
          delete userInfoRead.point_logo;
          delete userInfoRead.favicon;
          delete userInfoRead.avatar;
          delete userInfoRead.rankImagePc;
          delete userInfoRead.rankImageSp;
          localStorage.setItem("userDetails", JSON.stringify(userInfoRead));
          // LocalStorage.innerLocalStorage.userDetails = JSON.stringify(userInfoRead);
          return JSON.stringify(userInfoRead);
        });
      });
    }
    return userDetailsString;
  }

  @Mutation
  private static getOrgSpecificData(): string | null {
    // OrgSpecificDataがlocalStorageに入っていたらそれを返す。
    // が、データ自体をリフレッシュするため事前をAPIからコールして取得しておく
    // const OrgSpecificDataString = LocalStorage.innerLocalStorage.orgSpecificData;
    const OrgSpecificDataString = localStorage.getItem("OrgSpecificData");
    if (OrgSpecificDataString) {
      const user = LocalStorage.getItem("userDetails");
      // const user = LocalStorage.innerLocalStorage.userDetails;
      if (user == null) {
        AuthApi.getICSession().then((result) => {
          const ic_session = JSON.parse(result);
          AuthApi.getUserInfoRead(ic_session.companyCd).then((userInfoRead) => {
            const OrgPageSpecific = {
              // #59042対応によりpage_logo、point_logo、faviconをローカルストレージ上に保存しないように修正
              organization: userInfoRead.organization_id,
              page_title: userInfoRead.page_title,
              //page_logo: userInfoRead.page_logo,
              page_color: userInfoRead.page_color,
              point_name: userInfoRead.point_name,
              //point_logo: userInfoRead.point_logo,
              //favicon: userInfoRead.favicon,
              default_thanks_message: userInfoRead.default_thanks_message
            };
            localStorage.setItem(
              "OrgSpecificData",
              JSON.stringify(OrgPageSpecific)
            );
            // LocalStorage.innerLocalStorage.orgSpecificData = JSON.stringify(
            //   OrgPageSpecific
            // );
            return JSON.stringify(OrgPageSpecific);
          });
        });
      } else {
        const userJson = JSON.parse(user);
        const OrgPageSpecific = {
          // #59042対応によりpage_logo、point_logo、faviconをローカルストレージ上に保存しないように修正
          organization: userJson.organization_id,
          page_title: userJson.page_title,
          //page_logo: userJson.page_logo,
          page_color: userJson.page_color,
          point_name: userJson.point_name,
          //point_logo: userJson.point_logo,
          //favicon: userJson.favicon,
          default_thanks_message: userJson.default_thanks_message
        };
        localStorage.setItem(
          "OrgSpecificData",
          JSON.stringify(OrgPageSpecific)
        );
        // LocalStorage.innerLocalStorage.orgSpecificData = JSON.stringify(
        //   OrgPageSpecific
        // );
        return JSON.stringify(OrgPageSpecific);
      }
      return OrgSpecificDataString;
    } else {
      const user = LocalStorage.getItem("userDetails");
      // const user = LocalStorage.innerLocalStorage.userDetails;
      if (user == null) {
        AuthApi.getICSession().then((result) => {
          const ic_session = JSON.parse(result);
          AuthApi.getUserInfoRead(ic_session.companyCd).then((userInfoRead) => {
            const OrgPageSpecific = {
              // #59042対応によりpage_logo、point_logo、faviconをローカルストレージ上に保存しないように修正
              organization: userInfoRead.organization_id,
              page_title: userInfoRead.page_title,
              //page_logo: userInfoRead.page_logo,
              page_color: userInfoRead.page_color,
              point_name: userInfoRead.point_name,
              //point_logo: userInfoRead.point_logo,
              //favicon: userInfoRead.favicon,
              default_thanks_message: userInfoRead.default_thanks_message
            };
            localStorage.setItem(
              "OrgSpecificData",
              JSON.stringify(OrgPageSpecific)
            );
            // LocalStorage.innerLocalStorage.orgSpecificData = JSON.stringify(
            //   OrgPageSpecific
            // );
            return JSON.stringify(OrgPageSpecific);
          });
        });
      } else {
        const userJson = JSON.parse(user);
        const OrgPageSpecific = {
          // #59042対応によりpage_logo、point_logo、faviconをローカルストレージ上に保存しないように修正
          organization: userJson.organization_id,
          page_title: userJson.page_title,
          //page_logo: userJson.page_logo,
          page_color: userJson.page_color,
          point_name: userJson.point_name,
          //point_logo: userJson.point_logo,
          //favicon: userJson.favicon,
          default_thanks_message: userJson.default_thanks_message
        };
        localStorage.setItem(
          "OrgSpecificData",
          JSON.stringify(OrgPageSpecific)
        );
        // LocalStorage.innerLocalStorage.orgSpecificData = JSON.stringify(
        //   OrgPageSpecific
        // );
        return JSON.stringify(OrgPageSpecific);
      }
    }
    return OrgSpecificDataString;
  }
}
